import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { getOrgRole } from '../roles';

const ENV = (import.meta as any).env;

type RoleGuardProps = {
  allowed: string[];          // e.g. ['administrator']
  children: React.ReactNode;  // guarded content
  redirectTo?: string;        // e.g. `/${ENV.VITE_APP_FIRST_PAGE}`
};

export function RoleGuard({ allowed, children, redirectTo = `/${ENV.VITE_APP_FIRST_PAGE}` }: RoleGuardProps) {

  const user = useSelector((state: any) => state.user);

  if (!allowed || allowed.length === 0) {
    return <>{children}</>;
  }

  const role = getOrgRole(user);

  // FLEXO-6112 (#3): the org role is populated asynchronously (SetUserAsync).
  // Guarded routes only ever mount for an authenticated user, so until the role
  // resolves we must WAIT rather than fall through to 'default' and deny — that
  // produced a transient /access-denied on first login that users could only
  // escape by clicking "go home". Render nothing while the role is still
  // loading; only evaluate once it is known (or the load has errored).
  if (!role && user?.SetUserAsyncStatus !== 'ERROR') {
    return null;
  }

  if (!allowed.includes(role || 'default')) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
}


